import AppWrapper from "../../components/cm/AppWrapper";
import LogPhone from "../../components/cm/Dashboard/FullPages/LogPhone";
import SideBarMain from "../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <LogPhone />
    </AppWrapper.WithSidebar>
  );
};
